<template>
  <el-dialog :visible.sync="showDialog" :title="$t('lang.语言设置')">
    <lang-set @save="showDialog = false" />
  </el-dialog>
</template>

<script>
import LangSet from "../lang-set/LangSet";
export default {
  name: "SetSysLang",
  components: {LangSet},
  data() {
    return {
      showDialog: false,
    }
  }
}
</script>

<style scoped>

</style>